module.exports = __webpack_public_path__ + "img/news4.cc147b4d.png";